import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-buttons d-flex align-items-center" }
const _hoisted_2 = { class: "desktop-auth-buttons d-none d-md-flex align-items-center" }
const _hoisted_3 = { class: "mobile-auth-placeholder d-md-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-primary me-2",
        "data-bs-toggle": "modal",
        "data-bs-target": "#authModal",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setModalTab('login')))
      }, " Accedi "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        "data-bs-toggle": "modal",
        "data-bs-target": "#authModal",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setModalTab('register')))
      }, " Registrati ")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "d-flex align-items-center bg-transparent border-0 text-start p-0 cursor",
        "data-bs-toggle": "modal",
        "data-bs-target": "#authModal",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setModalTab('login')))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "flex-shrink-0" }, [
          _createElementVNode("span", { class: "rounded-circle wh-40 d-flex align-items-center justify-content-center bg-secondary text-white fs-20" }, [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "person")
          ])
        ], -1)
      ]))])
    ])
  ]))
}